import React, { useState } from "react";

import chevronDown from "../../assets/svg/chevron-down.svg";
import { useVehicleSelection } from "../../providers/VehicleSelectionContext.tsx";
import Header from "../elements/Header.tsx";
import { OrderBreakdownRow } from "./OrderBreakdownRow.tsx";
import { OrderFooter } from "./OrderFooter.tsx";

/**
 * OrderBreakdown component displays a collapsible section showing the cart items
 * with a consistently large label and toggle functionality.
 * The dropdown can be toggled by clicking the header section.
 */
const OrderBreakdown: React.FC = () => {
  const [isOpen, setIsOpen] = useState(true);

  const { products, productsByGroup } = useVehicleSelection();

  return (
    <div className="relative bg-[#262626] rounded-t-none w-full font-montserrat lg:bg-gray-100 lg:rounded-t-xl">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full p-4 text-lg bg-transparent appearance-none border-0 lg:border-b-2 border-black focus:outline-none focus:border-black text-gray-900 text-left flex items-center justify-between"
      >
        <Header size="2xl" hideUnderline className="text-white lg:text-black">
          Order Breakdown
        </Header>
        <img
          src={chevronDown}
          alt="chevron-down"
          className={`w-6 h-6 transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
        />
      </button>

      <div
        className={`left-0 right-0 bg-[#262626] lg:bg-gray-100 transition-all duration-300 ease-in-out z-10 ${
          isOpen ? "opacity-100 overflow-y-auto" : "max-h-0 opacity-0"
        }`}
        style={{ top: "100%" }}
      >
        {isOpen && (
          <div className="p-4 space-y-4">
            {products.length === 0 ? (
              <p className="text-gray-500">No products in cart</p>
            ) : (
              productsByGroup.map(({ step, entry, options }, index) => (
                <div className="space-y-4" key={index}>
                  <div className="border-b flex justify-between items-center border-b-white lg:border-b-black flex-wrap lg:flex-nowrap pb-1 lg:pb-0">
                    <Header
                      size="xl"
                      hideUnderline
                      className="text-white lg:text-black"
                    >
                      {entry ? entry.entry_name : step!.step_name}
                    </Header>
                    {entry?.entry_description && (
                      <div
                        className="text-2xs"
                        dangerouslySetInnerHTML={{
                          __html: entry.entry_description,
                        }}
                      />
                    )}
                  </div>
                  <div className="space-y-4" key={index}>
                    {options.map((product, index) => (
                      <OrderBreakdownRow option={product} key={index} />
                    ))}
                  </div>
                </div>
              ))
            )}

            <hr className="my-4 hidden lg:block" />

            <OrderFooter />
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderBreakdown;
